module.exports = __webpack_public_path__ + "img/logo_dark.1a7661dd.png";